import { Form, field, validate } from '@reckon-web/forms';

import {
  validateEmail,
  validatePassword,
  validatePhoneNumber,
} from '../../../utils/validations';

export const SingupFormSchema = field.object({
  email: field.text({
    validate: validate(validateEmail),
  }),
  firstname: field.text({
    validate: validate((value) => {
      if (!value.length) return validate.error('Enter your firstname');
      return value;
    }),
  }),
  lastname: field.text({
    validate: validate((value) => {
      if (!value.length) return validate.error('Enter your lastname');
      return value;
    }),
  }),
  country: field.select()({
    validate: validate((value) => {
      validate.required(value);
      return value;
    }),
  }),
  phonenumber: field.text({
    validate: validate(validatePhoneNumber),
  }),
  password: field.text({
    validate: validate(validatePassword),
  }),
});

export type SignUpFormInstance = Form<typeof SingupFormSchema>;
export type SignUpFormData = SignUpFormInstance['value'];
